import moment, { Moment } from "moment";
import MissionMap_Entity, {
  Engagement,
  Interactor,
  Message,
  ProjectRoster,
} from "./missionMap";
import { AppConfig } from "../../environement";
export default class MissionMap extends MissionMap_Entity {
  static fromList(missionMapsJSON: unknown): Array<MissionMap> {
    const missionMaps: MissionMap[] = [];
    if (missionMapsJSON)
      Array.isArray(missionMapsJSON) &&
        missionMapsJSON.forEach((missionMapJSON) => {
          missionMaps.push(new MissionMap(missionMapJSON));
        });
    return missionMaps;
  }

  onboardNow() {
    const apiEndpoint = AppConfig.api.endpoint;
    let endpoint = "live";
    if (apiEndpoint.includes("beta")) endpoint = "beta";
    if (apiEndpoint.includes("demo")) endpoint = "demo";

    window.location.replace(
      `https://payments.${endpoint}.rhapsody.la/onboarding?token=${this?.PublicToken}`,
    );
  }

  onboardingRequired() {
    return (
      this?.OnboardingRequiredForContract &&
      this?.BookletToken &&
      !this.PayrollOnboarded
    );
  }

  defaultPieceOnly(): boolean {
    return (
      this.Pieces?.length === 1 &&
      !this.Pieces[0]?.Title &&
      !this.Pieces[0]?.Description
    );
  }

  sameInteractors(): Interactor[] {
    let ret: Interactor[] = [];

    this?.Projects?.forEach((p, k) => {
      if (k === 0) {
        ret.push(...p.Interactors);
        return;
      }
      p.Interactors.forEach((i) => {
        if (ret.findIndex((e) => e.ID === i.ID) === -1) {
          ret = [];
        }
      });
    });

    return ret.filter((p) => p.SegueID && p.Description !== "contract");
  }

  rosters() {
    const ret: ProjectRoster[] = [...(this.ProjectRosters ?? [])];
    this.Messages.forEach((e) => {
      e.Data?.ProjectRosters?.forEach((r) => {
        const find = ret.find((e) => e.URL === r.URL);
        if (!find) ret.push(r);
      });
    });

    return ret;
  }

  allMessages(): (Message & { token?: string })[] {
    const ret: (Message & { token?: string })[] = [];

    this.Messages.forEach((m) => {
      if (!m.Name.includes("Contract")) ret.push(m);
    });
    this.Projects?.forEach((e) => {
      let messages: (Message & { token?: string })[] = JSON.parse(
        JSON.stringify(e.Messages),
      );
      messages?.forEach((m) => (m.token = e.PublicToken));
      messages = messages?.filter((m) => !m.Name.includes("Contract"));
      ret.push(...messages);
    });

    return ret;
  }

  seasonMessages(): Message[] {
    const ret: Message[] = [];
    const allMessages = this.allMessages();
    allMessages.forEach((e) => {
      const similarMessages = allMessages.filter(
        (m) => m.CreatedAt === e.CreatedAt,
      );
      if (
        similarMessages?.length &&
        ret?.findIndex((f) => f.CreatedAt === e.CreatedAt) === -1
      ) {
        ret.push(e);
      }
    });

    return ret;
  }

  allEgagements(): Engagement[] {
    const ret: Engagement[] = [];
    this.Engagements.forEach((e) => {
      ret.push(...e.Content);
    });

    return ret;
  }

  allInteractors(): Interactor[] {
    const ret: Interactor[] = [];

    this.Interactors?.forEach((e) => {
      if (e.Description !== "contract") {
        ret.push(e);
      }
    });

    this.Projects?.forEach((e) => {
      const i = e.Interactors?.filter((e) => e.Description !== "contract");
      ret.push(...i);
    });

    return ret;
  }

  contractInteractors(): (Interactor & { token?: string })[] {
    const ret: (Interactor & { token?: string })[] = [];

    this.Interactors?.forEach((e) => {
      if (e.Description === "contract") {
        ret.push({ ...e, token: this.PublicToken });
      }
    });

    this.Projects?.forEach((e) => {
      const i = e.Interactors?.filter((e) => e.Description === "contract");
      ret.push(
        ...i.map((interactor) => ({ ...interactor, token: e.PublicToken })),
      );
    });

    return ret;
  }

  dateRange() {
    let min: Moment;
    let max: Moment;

    const allEngagements = this.allEgagements();
    if (allEngagements.length === 0) return "";

    allEngagements.forEach((e) => {
      const from = moment(e.DateFromUTC);
      const to = moment(e.DateToUTC);

      if (!min) min = from;
      if (!max) max = to;

      if (from.isBefore(min)) min = from;
      if (to.isAfter(max)) max = to;
    });

    if (min!.isSame(max!, "day")) return min!.format("ll");

    return `From ${min!.format("ll")} to ${max!.format("ll")}`;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
